import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const CheckboxIdle = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 18 18">
      <path d="M15.3687 0.507813H2.63056C2.06764 0.50785 1.52778 0.731467 1.1297 1.12949C0.731623 1.52751 0.50793 2.06734 0.507813 2.63026V15.3687C0.507753 15.9317 0.731364 16.4717 1.12945 16.8699C1.52755 17.2681 2.06751 17.4918 2.63056 17.4919H15.3687C15.6475 17.4919 15.9236 17.437 16.1812 17.3303C16.4388 17.2236 16.6729 17.0672 16.87 16.87C17.0672 16.6729 17.2236 16.4388 17.3303 16.1812C17.437 15.9236 17.4919 15.6475 17.4919 15.3687V2.63026C17.4917 2.06727 17.268 1.52738 16.8698 1.12935C16.4716 0.731327 15.9317 0.507755 15.3687 0.507813ZM15.3687 15.3686H2.63056V2.63026H15.3687V15.3686Z" fill="currentColor"/>
    </SvgIcon>
  );
};

export default CheckboxIdle;
